import axios from "axios"
import * as actions from "../actions/auth"
import { ROLE_CANDIDATE, ROLE_GOVERNMENT } from '../js/const'

/* check token is valid and then get the groups and username of the logged in user */
export function checkAuthToken() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.REACT_APP_API_HOST}/api/user/check-auth-token`)
        .then(response => {
          if (response && response.status === 200) {
            dispatch(actions.setAuthenticated(response.data.IsAuthenticated))
            dispatch(actions.setUsername(response.data.Name))
            dispatch(actions.setRoles([response.data.Group]))
            dispatch(actions.setCandidateId(response.data.CandidateId))
          } else {
            performLogout()
          }
          if(response){
            resolve(response)            
          }
        })
        .catch(error => {
          performLogout()
          reject(error)
        })
    })
  }
}

export function performLogin(userLoginDetails) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      // there are issues when the bearer token is being passed into the url used to get the token so remove here
      sessionStorage.removeItem('authorizationData')
      var data = `grant_type=password&username=${userLoginDetails.Username}&password=${encodeURIComponent(userLoginDetails.Password)}`
      axios.post(process.env.REACT_APP_API_HOST + "/token", data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          if (response && response.data && response.data.access_token) {
            sessionStorage.setItem('authorizationData', JSON.stringify({ token: response.data.access_token, refreshToken: response.data.refresh_token }));
            dispatch(actions.setAuthenticated(true))
            dispatch(actions.setUsername(userLoginDetails.Username))
            if (response.data[ROLE_GOVERNMENT]) {
              dispatch(actions.setRoles([ROLE_GOVERNMENT]))
            } else if (response.data[ROLE_CANDIDATE]) {
              dispatch(actions.setRoles([ROLE_CANDIDATE]))
            }

            if (response.data.CandidateId) {
              dispatch(actions.setCandidateId(Number(response.data.CandidateId)))
            }
          }
          else {
            performLogout()
          }
          resolve(response)
        })
        .catch(error => {
          performLogout()
          reject(error)
        })
    })
  }
}

export function performLogout() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.REACT_APP_API_HOST}/api/user/logout`)
        .then(response => {
          sessionStorage.removeItem('authorizationData')
          dispatch(actions.setAuthenticated(false))
          dispatch(actions.setUsername(''))
          dispatch(actions.setRoles([]))
          dispatch(actions.setCandidateId(null))
          resolve(response)
        })
    })
  }
}

export function getForgotPasswordDetails() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/user/forgot-password`)
      .then((response) => {
        let forgotPasswordDetails = response ? response.data : {}
        dispatch(actions.getForgotPasswordDetails(forgotPasswordDetails))
      })
  }
}

export function sendPasswordLink(email) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.REACT_APP_API_HOST}/api/user/send-password-link`, { email })
        .then(response => {
          resolve(response)
        })
    })
  }
}

export function resetPassword(details) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.REACT_APP_API_HOST}/api/user/reset-password`, details)
        .then(response => {
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function checkTokenValidity(token) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.REACT_APP_API_HOST}/api/user/check-reset-token`, { token })
        .then(response => {
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function setCheckedForUserToken(hasCheckedForUserToken) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.setCheckedForUserToken(hasCheckedForUserToken))
      resolve()
    })
  }
}

export function getChangePasswordDetails(candidateId) {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/user/change-password/${candidateId}`)
      .then((response) => {
        let changePasswordDetails = response ? response.data : {}
        dispatch(actions.getChangePasswordDetails(changePasswordDetails))
      })
  }
}

export function changePassword(details) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.REACT_APP_API_HOST}/api/user/change-password`, details)
        .then(response => {
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function getLoginDetails() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.REACT_APP_API_HOST}/api/user/login`)
        .then(response => {
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function clearSessionTimeOut() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.clearSessionTimeOut())
      resolve()
    })
  }
}



// WEBPACK FOOTER //
// ./src/actionCreators/auth.js